document.addEventListener("DOMContentLoaded", () => {
  if (typeof GLightbox === "undefined") {
    return;
  }

  const root = document.querySelector(".expert-voice-single");
  if (!root) {
    return;
  }

  const triggers = root.querySelectorAll(".evs-glightbox");
  if (!triggers.length) {
    return;
  }

  GLightbox({
    selector: ".expert-voice-single .evs-glightbox",
    touchNavigation: true,
    loop: false,
  });
});
